import {
  WorkImportCandidatePageResponse,
  WorkImportSourceListResponse,
} from '../dto/ResDtoRepository';
import { sendApiRequest } from './apiConfig';

export const getWorkImportSources = async (
  aui: string,
): Promise<WorkImportSourceListResponse> => {
  const params = new URLSearchParams({ aui });
  return sendApiRequest<WorkImportSourceListResponse>(
    'get',
    `/api/v1/work/import/source/list/owner?${params.toString()}`,
  );
};

export const getWorkImportCandidates = async (
  aui: string,
  groupMemberId: number,
  page: number,
  size: number,
  tagIds: number[],
): Promise<WorkImportCandidatePageResponse> => {
  const params = new URLSearchParams({
    aui,
    groupMemberId: String(groupMemberId),
    page: String(page),
    size: String(size),
  });
  tagIds.forEach((tagId) => params.append('tagIds', String(tagId)));
  return sendApiRequest<WorkImportCandidatePageResponse>(
    'get',
    `/api/v1/work/import/candidate/list/owner?${params.toString()}`,
  );
};
